import { FC, useEffect, useState } from 'react'
import { ErrorMessage, Formik } from 'formik'
import {
  createAccountSchemas,
  ICreateAccount,
  inits,
} from '../wizards/components/CreateAccountWizardHelper'
import { useAuth } from '../auth'
import axios from 'axios'
import './Plans.css'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const plans = [
  {
    title: "Starter Anual",
    titleComplete: "Adinte Starter Anual",
    type: "anual",
    priceNumber: "2,990",
    priceText: "+ IVA al año",
    stripeValue: "STARTER-ANUAL",
    features: [
      { title: "Ideal para 1-2 abogados" },
      { title: "Hasta 30 expedientes" },
      { title: "Gestión básica de expedientes" },
      { title: "Soporte por correo" },
      { title: "Garantía de reembolso" },
    ]
  },
  {
    title: "Professional Anual",
    titleComplete: "Adinte Professional Anual",
    type: "anual",
    priceNumber: "5,990",
    priceText: "+ IVA al año",
    stripeValue: "PROFESSIONAL-ANUAL",
    features: [
      { title: "Pensado para equipos de 3-5 personas" },
      { title: "Hasta 100 expedientes" },
      { title: "Carga masiva de expedientes" },
      { title: "Soporte avanzado" },
      { title: "Garantía de reembolso" },
    ]
  },
  {
    title: "Starter Mensual",
    titleComplete: "Adinte Starter Mensual",
    type: "mensual",
    priceNumber: "299",
    priceText: "+ IVA al mes",
    stripeValue: "STARTER-MENSUAL",
    features: [
      { title: "Ideal para 1-2 abogados" },
      { title: "Hasta 30 expedientes" },
      { title: "Gestión básica de expedientes" },
      { title: "Soporte por correo" },
    ]
  },
  {
    title: "Professional Mensual",
    titleComplete: "Adinte Professional Mensual",
    type: "mensual",
    priceNumber: "599",
    priceText: "+ IVA al mes",
    stripeValue: "PROFESSIONAL-MENSUAL",
    features: [
      { title: "Pensado para equipos de 3-5 personas" },
      { title: "Hasta 100 expedientes" },
      { title: "Carga masiva de expedientes" },
      { title: "Soporte avanzado" },
    ]
  }
]

const Plans: FC = () => {
  const API_URL = process.env.REACT_APP_API_URL
  const { currentUser } = useAuth()

  const [currentSchema] = useState(createAccountSchemas[0])
  const [initValues] = useState<ICreateAccount>(inits)

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    if (query.get('success')) {
      const formData = {
        email: currentUser?.email,
        session_id: query.get('session_id'),
        plan: query.get('plan'),
        subscription: query.get('subscription'),
      }
      axios.post(API_URL + '/app/registrar-suscripcion', formData).then(() => {
        window.location.href = '../'
      })
    }
  }, [])

  const monthlyPlans = plans.filter(p => p.type === 'mensual')
  const annualPlans = plans.filter(p => p.type === 'anual')

  const renderPlanCard = (plan: any) => {
    const isPro = plan.title.includes('Professional')

    return (
      <div className={`card card-plan h-100 ${isPro ? 'plan-pro' : ''}`}>
        <div className="p-4 h-100 d-flex flex-column">

          <h3 className="plan-title">{plan.titleComplete}</h3>

          <div className="plan-price">
            <span className="currency">$</span>
            <span className="price-number">{plan.priceNumber}</span>
            <span className="price-text"> {plan.priceText}</span>
          </div>

          <div className="flex-grow-1 mt-4">
            {plan.features.map((feature: any, i: number) => (
              <div className="d-flex align-items-center mb-3" key={i}>
                <img
                  src={toAbsoluteUrl('/media/icons/icono-check.png')}
                  className="me-3"
                  width={18}
                />
                <span>{feature.title}</span>
              </div>
            ))}
          </div>

          <form action={API_URL + '/stripe/checkout'} method="POST">
            <input type="hidden" name="plan" value={plan.title} />
            <input type="hidden" name="lookup_key" value={plan.stripeValue} />
            <input type="hidden" name="customer_email" value={currentUser?.email} />

            <button className="btn btn-primary w-100 mt-4" type="submit">
              Comienza ahora
            </button>
          </form>

        </div>
      </div>
    )
  }

  return (
    <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={() => {}}>
      <div className="container-fluid px-2 px-lg-4">

        <h1 className="text-center mb-5">Selecciona tu plan</h1>

        <div className="row align-items-stretch">

          {/* MENSUALES */}
          <div className="col-lg-6 d-flex flex-column">
            <div className="info-header">
              <h2>Planes mensuales</h2>
              <p className="fw-bold">Para despachos que prefieren flexibilidad mes a mes.</p>
              <p className="text-gray-600">Cancela tu suscripción en cualquier momento.</p>
            </div>

            <div className="row justify-content-center">
              {monthlyPlans.map((plan, i) => (
                <div className="col-md-6 col-lg-5 px-2 mb-4 d-flex" key={i}>
                  {renderPlanCard(plan)}
                </div>
              ))}
            </div>
          </div>

          {/* ANUALES */}
          <div className="col-lg-6 plans-divider d-flex flex-column">
            <div className="info-header annual-header">
              <h2>Planes anuales</h2>
              <img
                src={toAbsoluteUrl("media/plans/img-ahorra.png")}
                className="ahorra-badge"
              />
              <p className="fw-bold">
                Para despachos que buscan estabilidad, ahorro y compromiso.
              </p>
              <p className="text-gray-600">
                Si en los primeros 30 días Adinte no aporta valor real a tu despacho, <b>te devolvemos el 100% de tu pago.</b>
              </p>
            </div>

            <div className="row justify-content-center">
              {annualPlans.map((plan, i) => (
                <div className="col-md-6 col-lg-5 px-2 mb-4 d-flex" key={i}>
                  {renderPlanCard(plan)}
                </div>
              ))}
            </div>
          </div>

        </div>

        <ErrorMessage name="accountType" className="text-danger mt-2" />

      </div>
    </Formik>
  )
}

export { Plans }